export default __webpack_public_path__ + "static/media/frente-noche.17043c42.jpg";